const translations = {
  "testStringId": "Test String",
  "propertySearchHeader": "Introduce us to your property",
  "selectCityCountry": "Select city, country of your property",
  "nextAction": "Next",
  "pinLocationTitle": "Help us pin your property's exact location",
  "buttonConfirmYes": "Yes",
  "buttonConfirmNo": "No",
  "yourCheclistHeading": "Your checklist",
  "yourChecklistDescription": "Please complete the remaining steps by clicking on 'Add' button",
  "completedTaskHeading": "Completed Tasks",
  "AddPropertyTask": "Add",
  "EditPropertyTask": "Edit",
  "previewPropertyTitle": "Go Live!",
  "previewPropertySubDescription": "Look at a preview of your property and list it right away on OYO",
  "letsGoButtonTitle": "Preview and Publish",
  "PublishPropertyButton": "Publish Property",
  "roomAmentiesTitleOVH": "Facilities available at your holiday home",
  "roomAmentiesTitle": "Facilities available at your property",
  "roomAmentiesSubTitle": "Tell us more about the services you offer",
  "signingIn": "Signing In",
  "mobileNumber": "Mobile Number",
  "propertyType": "Property Type",
  "country": "Country",
  "city": "City",
  "address": "Address",
  "nameOfHotel": "Title of the Property",
  "frontdeskPhoneNumber": "Frontdesk Phone Number",
  "propertyNotFoundInOTAText": "Property Not found",
  "Download_sample_form": "Download sample form",
  "IsGSTINNumberAvailable": "Is GSTIN Number Available ?",
  "KYC_details": "KYC Details",
  "Submit": "Submit",
  "Save": "Save",
  "enterOTP": "Enter verification code",
  "otpSent": "OTP Sent",
  "resendCode": "Resend Code",
  "edit": "Edit",
  "otpMessage": "A 4-digit code was sent to your mobile number",
  "PICK_CURRENT_LOCATION": "Tap here to pick your current location",
  "GUEST_ARRIVE_HERE": "Your guests will arrive here. Place the pin on exact hotel location.",
  "addPropertyImages": "Add Property Images",
  "photoAssistanceText": "Don’t have good quality images? We can help you out.",
  "learnMore": "Learn More",
  "reupload": "Reupload",
  "uploadPhotos": "Upload Photos",
  "addAnother": "Add Another",
  "resolveImageError": "Resolve Image Error ({number})",
  "resolveImageWarning": "Resolve Image Warning ({number})",
  "imageCategory": "Image Category",
  "skip": "Skip Warnings",
  "errors": "Errors",
  "warnings": "Warnings",
  "tips": "Tips",
  "readMore": "...Read More",
  "readLess": "...Read Less",
  "minimumPhotos": "Please upload a minimum of {number, plural, one { 1 good image } other { # good images }}",
  "TELL_US_ABOUT_PROPERTY": "Tell us more about your property",
  "INTRODUCE_TO_PROPERTY": "Introduce us to your property",
  "typeOfRoomsPropertyHave": "What type of rooms do you offer at your property?",
  "addRoomsLater": "You can add more room categories later",
  "isRightProperty": "Is this your property?",
  "fetchedInfo": "We found this information from a few sources available online",
  "totalRooms": "Total number of rooms",
  "availableRoom": "Available Rooms",
  "buttonActionSave": "Save",
  "buttonActionSubmit": "Submit",
  "buttonActionContinue": "Continue",
  "descriptionTitle": "Description",
  "amenitiesTitle": "Amenities",
  "roomSectionTitle": "Room Type",
  "roomCategoryCount": "{number} Rooms",
  "taskErrorCount": "{number} errors encountered",
  "termsOfService": "Terms of Service",
  "termsOfServiceFooter": "Please read our {termsOfService}.",
  "viewSample": "Please view sample contract",
  "generateContractMessage": "Generating your contract,Please wait!",
  "oneMinute": "1 minute",
  "generateContractSubtitle1": "Your property details are under review. It will take less than {oneminute}.",
  "generateContractSubtitle2": "Hold on! We are working on it.",
  "contractAgreementMessage": "I agree to the {linkedText}",
  "listOnOyo": "List on OYO",
  "oyoTermsAndServicesText": "OYO’s Terms of Service",
  "name": "Name",
  "contactNumber": "Contact Number",
  "roomNumber": "Number of Rooms",
  "panNumber": "PAN Number",
  "bussinessID": "Bussiness ID",
  "contractHeader": "Contract",
  "viewMyProperties": "View my properties",
  "reviewDocuments": "Congratulations! Your property is now LIVE. Download the CO-OYO App to start accepting your bookings.",
  "congratulation": "Welcome Aboard",
  "downloadAppText": "Download App",
  "downloadAppContent": "Manage your property on Co-OYO app",
  "loginToCooyoHeader": "How to login to Co-OYO",
  "loginToCooyoContent": "Please login with your registered mobile number ({mobNumber}) to access your account on the app",
  "previewMapLocatorTitle": "Map",
  "mobConflictBottomBtnTitle": "Link a different mobile number",
  "mobConflictCardDescription": "This will remove the current email address",
  "mobConflictBottomBtnDescription": "Go back and try linking different mobile number to email",
  "mobConflictMsgHeader": "We found a profile with entered mobile number",
  "mobConflictMsgDescription": "{countryCode} {mobileNumber} is linked to another email. Please link a different mobile number or switch profile.",
  "emailConflictBottomBtnTitle": "Link a different email address",
  "emailConflictCardDescription": "This will remove the current mobile number",
  "emailConflictBottomBtnDescription": "Go back and try linking different email to mobile number",
  "emailConflictMsgHeader": "We found a profile with entered email address",
  "emailConflictMsgDescription": "{email} is linked to another mobile number. Please link a different email or switch profile.",
  "multipleProfileScreenHeader": "Resolve an issue",
  "verify": "Verify",
  "update": "Update",
  "emailUpdated": "Email Updated Successfully",
  "duplicateEmailMessage": "This email is already in use. Please use a different one.",
  "emailVerifyModalMsg": "A 4-digit code was sent to your email address ",
  "mobVerifyModalMsg": "A 4-digit code was sent to your mobile number ",
  "verifyKYCModalHeader": "Enter OTP to verify",
  "switchProfileTitle": "Switch to this profile",
  "imageNotUploadedMessage": "This image has already been uploaded. Please re-upload a new image",
  "invalidInput": "Invalid input",
  "footerAccountTitle": "Account",
  "footerMyPropertiesTitle": "My Properties",
  "myProperties": "My Properties",
  "continueListing": "Continue listing",
  "preview": "Preview",
  "deletedLater": "Uploaded images can be deleted later through Co OYO app",
  "uploadedImages": "{number, plural, one { 1 image } other { # images }} uploaded",
  "atleastImages": " Upload atleast {number, plural, one { 1 image } other { # images }}",
  "outOfImages": "{num1} out of {num2, plural, one { 1 image } other { # images }} uploaded",
  "allImagesUploaded": "All images uploaded",
  "gotIt": "Got it",
  "viewSampleImages": "View sample images",
  "oyoGuideLine": "Please click on the cross button on each image to delete. You will be able to publish your property only once each of the below images are deleted.",
  "goToDashboard": "Go to dashboard",
  "accountMyOyoText": "My OYO",
  "listNewProperty": "List new property",
  "faqs": "FAQs",
  "requestCallback": "Request a callback",
  "partnerPolicy": "Partner policy",
  "signOut": "Sign out",
  "noPropertiesText": "No properties",
  "noPropertiesContent": "Let us help you increase your occupancy rates and net revenue",
  "addProperty": "Add a property",
  "leads": "In-progress ({number})",
  "properties": "Your Live Listings ({number})",
  "notOperationalMessage": "{city}, {country} (We are not currently operational in this area.)",
  "chooseLanguage": "Choose a Language",
  "currentLanguage": "CURRENT LANGUAGE",
  "otherLanguages": "OTHER LANGUAGES",
  "addNew": "Add Property",
  "errorModalTitle": "Image error ({number})",
  "imagePreviewTitle": "Preview of {title} images",
  "coverImageOfProperty": "Cover Image of Property",
  "coverImageOfPropertyDescription": "An exotic glimpse of your property to invite guests",
  "updatingInfo": "Updating Info",
  "settingUpProperty": "Setting up your property",
  "downloadContract": "Download Contract",
  "enterCorrectEmail": "Please enter correct email address",
  "notOperationalText": "We are not operational in this area . Please select correct location.",
  "imageUploadedSuccessfully": "Image Uploaded Successfully",
  "imageUploadedFailed": "Image Upload Failed.Please try again.",
  "totalFloors": "Available Floors",
  "mandatoryAmenities": "(Mandatory)",
  "incorrectOtp": "Incorrect OTP",
  "otaLocationUpdateMessage": "Selected location is different from the location in our records. Please confirm if you want to proceed with same.",
  "countryUpdateMessage": "Selected country is different from the country in our records. We don't allow country change for a property.",
  "confirm": "Confirm",
  "cancel": "Cancel",
  "inactiveProperties": "Press ‘Reactivate’ to make them LIVE on OYO",
  "inactivePropertiesHeader": "Your Properties currently Inactive ({number})",
  "reactivate": "Reactivate",
  "removeListing": "Remove listing",
  "dissociationPropertyMessage": "Please confirm you are no longer associated with the listed property.",
  "inactiveMsg": "Inactive from {number} months",
  "previewPageHeader": "Property Preview Page",
  "previewPageSubHeader": "This is how your property will look like once it is published.",
  "previewPageFooterText": "On the next screen you can review the terms and conditions before you list your property online.",
  "previewPageFooterTextOvh": "On submitting the information a Belvilla rental expert will reach out to you to discuss & publish your holiday home.",
  "backToEdit": "Back to edit",
  "back": "Back",
  "underReviewBelvilla": "Under review by Belvilla",
  "ovhPropertyLive": "Property is live",
  "IMAGE_DELETE_SUCCESS_MESSAGE": "Image deleted successfully!",
  "rejectedImages": "{number, plural, =1 {1 image violates OYO guidlelines. Please delete!} other {{number} images violate OYO guidlelines. Please delete! }}",
  "REJECT_IMAGES_STATUS": "{numOfImages, plural, =1 {1 Photo rejected. Please review} other {{numOfImages} Photos rejected. Please review}}",
  "ACCEPT_IMAGES_STATUS": "{numOfImages, plural, =1 {1 Photo accepted} other {{numOfImages} Photos accepted}}",
  "REJECT_IMAGES": "{numOfImages, plural, =1 {1 photo was not uploaded as photo is larger than 10MB. Please re-upload image with smaller file size} other {{numOfImages} photos were not uploaded as photos are larger than 10MB. Please re-upload images with smaller file size}}",
  "DUPLICATE_IMAGES_STATUS": "{numOfImages, plural, =1 {1 duplicate photo rejected} other {{numOfImages} duplicate photos rejected}}",
  "NOT_UPLOADED_IMAGES_STATUS": "{numOfImages, plural, =1 {1 Photo} other {{numOfImages} Photos}} could not be uploaded.",
  "DISMISS": "Dismiss",
  "kycDeclarationHeader": "Confirm & Submit KYC",
  "acceptAndSubmit": "Accept & Submit",
  "property_preview_ovh": {
    previewPageHeader: 'Holiday Home Preview',
    previewPageSubHeader: 'See how your home will look like when it is published.',
    previewPageFooterText:
      'On submitting the information a Belvilla rental expert will reach out to you to discuss & publish your holiday home.',
    PublishPropertyButton: 'Submit',
    backToEdit: 'Back to edit',
    previewMapLocatorTitle: 'Map',
    descriptionTitle: 'Description',
    amenitiesTitle: 'Amenities',
    roomCategoryCount: '{number} Rooms',
    roomSectionTitle: 'Room Type'
  },
  "property_preview_oyo": {
    previewPageHeader: 'Property Preview Page',
    previewPageSubHeader: 'This is how your property will look like once it is published.',
    previewPageFooterText:
      'On the next screen you can review the terms and conditions before you list your property online.',
    PublishPropertyButton: 'Publish Property',
    backToEdit: 'Back to edit',
    previewMapLocatorTitle: 'Map',
    descriptionTitle: 'Description',
    amenitiesTitle: 'Amenities',
    roomCategoryCount: '{number} Rooms',
    roomSectionTitle: 'Room Type'
  },
  "IN_PROCESSING_IMAGES_STATUS": "{numOfImages, plural, =1 {1 Photo is} other {{numOfImages} Photos are}} still being processed. Please check this page in a few mins!",
  "UPLOAD_SUCCESS_STATUS_L1": "{numOfImages, plural, =1 {1 image} other {{numOfImages} images}} uploaded",
  "PROCESSING": "Processing...",
  "UPLOADING": "Uploading...",
  "NEW": "New",
  "IMAGE_SIZE_AND_FORMAT_ERROR": "{count, plural, =0 {Image} one {1 image} other {{count} images}} could not be uploaded. Please ensure only .jpg, .png, .jpeg files with file size less than 10 MB",
  "API_FAILURE_MESSAGE": "Something went wrong. Try Again!",
  "IMAGE_UPLOAD_DISABLED_MESSAGE": "You are not allowed to upload images",
  "IMAGE_DELETION_DISABLED_MESSAGE": "You can only delete images that were recently uploaded",
  "PERCENTILE_UPLOADED": "{percentile}% uploaded...",
  "SESSION_EXPIRED": "Session Expired",
  "errorCardRetryButtonTitle": "Retry",
  "dataWithPercentage": "{data}%",
  "startDateEndDate" : "{start_date}-{end_date}",
  "textWithPlusSign": '+{data}',
  "IMAGE_SIZE_AND_TYPE_ERROR": "{count, plural, =0 {Image} one {1 image} other {{count} images}} could not be uploaded. Please ensure only .jpg, .png, .jpeg files with file size less than 10 MB",
  "IMAGE_OREINTATION_ERROR": "{count, plural, =0 {Image} one {1 image} other {{count} images}} could not be uploaded. Vertical images are not supported. Please upload horizontal (landscape) images only.",
  "IMAGE_RESOLUTION_ERROR": "{count, plural, =0 {Image} one {1 image} other {{count} images}} could not be uploaded. Please ensure minimum Resolution is 1000 x 1000 px",
  "IMAGE_PROCCESSING_ERROR": "{count, plural, =0 {Image} one {1 image} other {{count} images}} could not be uploaded. something went wrong",
  "LEAD_DATA" :"{copy_lead_label}{lead_id}",
};

export default translations;
